import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceRuleApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'attendance-rule'
  }

}